<template>
  <section>
    <div v-if="isAddingEvent" class="addBox" :style="addStyle">
      <AddEvent :day="this.curDate" :option="option" />
    </div>
    <div
      @dragenter="showDropArea = true"
      @mouseout="showDropArea = false"
      @drop="showDropArea = false"
      @click="handleClick($event)"
    >
      <div id="backBox"></div>
      <Navbar />

      <!-- 3 columns for main page -->
      <div class="mainFlex">
        <!-- FIRST COLUMN -->
        <div class="calendarColumn">
          <router-link
            class="calendarColumnRow"
            @click.native="setMessageBoard"
            :class="{
              onChat: onMessageBoard,
            }"
            :to="{
              name: 'MessageBoard',
              params: {
                name: this.groupName.replace(/\s/g, '-'),
                id: this.groupId,
              },
            }"
            ><img
              class="calendarGroupImg backArrow"
              src="@/assets/Calendar/calArrow.svg"
            />
            <div class="calendarGroupTitle">Back to chat</div></router-link
          >

          <div class="calendarColumnRow" @click="viewCalendar('Month')">
            <img class="calendarGroupImg" :src="currentImg" />
            <!--div class="calendarGroupTitle">{{ this.nameGroup }} Calendar</div-->
            <select v-model="groupCal" class="selectDesignCal">
              <option value="All">All</option>
              <template v-for="(group, groupIndex) in user.allGroups">
                <template v-if="group.type !== 'directMessages'">
                  <option :value="group" :key="groupIndex"
                    >{{ group.name }} Calendar</option
                  >
                </template>
              </template>
            </select>
          </div>
          <div class="calendarColumnTitle">Calendar View</div>
          <div class="calendarColumnRow" @click="viewCalendar('Month')">
            <img
              class="calendarColumnImg"
              src="@/assets/Calendar/calMonth.png"
            />
            <div class="calendarColumnText">
              Month
            </div>
          </div>
          <div class="calendarColumnRow" @click="viewCalendar('Schedule')">
            <img
              class="calendarColumnImg"
              src="@/assets/Calendar/calSchedule.png"
            />
            <div class="calendarColumnText">Schedule</div>
          </div>
          <!--div class="calendarColumnRow" @click="viewCalendar('Week')">
            <img
              class="calendarColumnImg"
              src="@/assets/Calendar/calWeek.png"
            />
            <div class="calendarColumnText">Week</div>
          </div-->
          <div class="calendarColumnTitle">Filters</div>
          <div
            class="calendarColumnRow calendarRowNoHover"
            @click="toggleFilter(0)"
          >
            <div
              class="calendarColumnPick assessmentFilter"
              :class="[toggledAssessment ? '' : 'notSelected']"
            >
              <img
                v-if="toggledAssessment"
                class="calendarCheckMark"
                src="@/assets/Calendar/checkMark.svg"
              />
            </div>
            <div>Assessment</div>
          </div>
          <div
            class="calendarColumnRow calendarRowNoHover"
            @click="toggleFilter(1)"
          >
            <div
              class="calendarColumnPick classFilter"
              :class="[toggledClass ? '' : 'notSelected']"
            >
              <img
                v-if="toggledClass"
                class="calendarCheckMark"
                src="@/assets/Calendar/checkMark.svg"
              />
            </div>
            <div>Class</div>
          </div>
          <div
            class="calendarColumnRow calendarRowNoHover"
            @click="toggleFilter(2)"
          >
            <div
              class="calendarColumnPick assignmentFilter"
              :class="[toggledAssignment ? '' : 'notSelected']"
            >
              <img
                v-if="toggledAssignment"
                class="calendarCheckMark"
                src="@/assets/Calendar/checkMark.svg"
              />
            </div>
            <div>Assignment</div>
          </div>
          <div
            class="calendarColumnRow calendarRowNoHover"
            @click="toggleFilter(3)"
          >
            <div
              class="calendarColumnPick officeFilter"
              :class="[toggledOffice ? '' : 'notSelected']"
            >
              <img
                v-if="toggledOffice"
                class="calendarCheckMark"
                src="@/assets/Calendar/checkMark.svg"
              />
            </div>
            <div>Office Hours</div>
          </div>
          <div
            class="calendarColumnRow calendarRowNoHover"
            @click="toggleFilter(4)"
          >
            <div
              class="calendarColumnPick otherFilter"
              :class="[toggledOther ? '' : 'notSelected']"
            >
              <img
                v-if="toggledOther"
                class="calendarCheckMark"
                src="@/assets/Calendar/checkMark.svg"
              />
            </div>
            <div>Other</div>
          </div>
          <div
            class="calendarColumnRow calendarRowNoHover"
            @click="toggleFilter(5)"
          >
            <div
              class="calendarColumnPick nonCourseFilter"
              :class="[toggledNon ? '' : 'notSelected']"
            >
              <img
                v-if="toggledNon"
                class="calendarCheckMark"
                src="@/assets/Calendar/checkMark.svg"
              />
            </div>
            <div>Non course</div>
          </div>
        </div>

        <!-- Calendar UI -->
        <div class="calendarContainer">
          <div class="outerCalendarCard" @scroll="calScroll($event)">
            <span
              v-if="this.option != 'Schedule'"
              class="calScrollArrow calLeftArrow"
              @click="changeCalendar('left')"
            >
              <img src="@/assets/Calendar/calArrow.svg" />
            </span>
            <div class="innerCalendarCard" v-if="this.option == 'Month'">
              <div class="monthBar">
                {{ this.lastMonth }} {{ this.lastYear }} ({{ this.nameGroup }})
              </div>
              <div class="dateBar">
                <div
                  class="dateBarContent"
                  v-for="(day, index) in days"
                  :key="index"
                >
                  {{ day }}
                </div>
              </div>
              <div
                class="calendarWeek"
                v-for="(week, index) in weeks"
                :key="index"
                :class="{ isLastCalendarWeek: index == weeks.length - 1 }"
              >
                <div
                  class="dateBox"
                  v-for="(day, date) in week"
                  :key="date"
                  :class="{ isLastDateBox: date == 6 }"
                >
                  <div class="dateNumber">
                    {{ day.num }}
                  </div>
                </div>
              </div>
            </div>
            <div
              class="innerCalendarCard"
              v-else-if="this.option == 'Week'"
            ></div>
            <div class="innerCalendarCard" id="innerCalendarCardWidth">
              <!-- Month View -->
              <div class="monthBar" v-if="this.option != 'Schedule'">
                {{ this.curMonth }} {{ this.curYear }} ({{ this.nameGroup }})
              </div>
              <div class="dateBar" v-if="this.option != 'Schedule'">
                <div
                  class="dateBarContent"
                  v-for="(day, index) in days"
                  :key="index"
                >
                  {{ day }}
                </div>
              </div>
              <div v-else class="monthBar">Schedule</div>
              <template v-if="this.option == 'Month'">
                <div
                  class="calendarWeek"
                  v-for="(week, index) in weeks"
                  :key="index"
                  :class="{ isLastCalendarWeek: index == weeks.length - 1 }"
                >
                  <div
                    class="dateBox"
                    @click="showBox(index, date, day, $event, 0)"
                    v-for="(day, date) in week"
                    :key="date"
                    :style="[date == 6 ? { 'border-right': 'white' } : {}]"
                  >
                    <div
                      class="dateNumber"
                      v-if="day.num != 0 && day.num != startNum"
                    >
                      {{ day.num }}
                    </div>
                    <div
                      class="dateNumber"
                      v-if="
                        day.num != 0 &&
                          day.num == startNum &&
                          day.month + 1 != startMonth
                      "
                    >
                      {{ day.num }}
                    </div>
                    <div
                      class="curNumber"
                      v-if="day.num == startNum && day.month + 1 == startMonth"
                    >
                      {{ day.num }}
                    </div>
                    <div
                      v-for="(event, eventIndex) in day.events"
                      :key="eventIndex"
                      :style="[
                        checkStartDate(event, day) ||
                        checkStartWeek(event, day) ||
                        checkEmpty(event) ||
                        eventIndex == day.events.length - 1
                          ? {}
                          : { 'pointer-events': 'none' },
                      ]"
                    >
                      <div
                        v-if="
                          day.events.length - 1 >= numberOfEvents &&
                            eventIndex < numberOfEvents
                        "
                      >
                        <CalendarItem
                          :event="event"
                          :day="day"
                          :events="events"
                          :index="index"
                        />
                      </div>
                      <div v-else-if="day.events.length - 1 < numberOfEvents">
                        <CalendarItem
                          :event="event"
                          :day="day"
                          :events="events"
                          :index="index"
                        />
                      </div>
                      <div v-else-if="eventIndex == day.events.length - 1">
                        <MultiCalendarItem
                          :events="day.events"
                          :number="numberOfEvents"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="this.option == 'Week'">
                <div
                  class="weekBox"
                  style="margin-top: 20px; border-bottom: 1px solid #b0b0b0"
                >
                  <div
                    class="weekColumn"
                    v-for="(day, index) in weeks[this.curWeek]"
                    :key="index"
                  >
                    {{ day.num }}
                    <div
                      v-for="(event, eventIndex) in day.events"
                      :key="eventIndex"
                      :style="[
                        checkStartDate(event, day) ||
                        checkStartWeek(event, day) ||
                        checkEmpty(event)
                          ? {}
                          : { 'pointer-events': 'none' },
                      ]"
                    >
                      <div v-if="event.days.length > 1 || event.isAllDay">
                        <CalendarItem
                          :event="event"
                          :day="day"
                          :events="events"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="weekContainer" :class="{ isWindow: isWindows }">
                  <div class="weekBox">
                    <div
                      class="weekColumn"
                      v-for="(day, index) in weeks[this.curWeek]"
                      :key="index"
                    >
                      <div
                        class="timeBox"
                        style="position: relative"
                        @click="showBox(0, index, day, $event, hour.hour)"
                        v-for="(hour, index2) in day.hours"
                        :key="index2"
                        :style="[
                          curHour == hour.hour && boxX == index
                            ? {
                                'background-color': '#e9e9e9',
                                'box-shadow': '7px 7px 5px #e0e0e0',
                              }
                            : {},
                          index == 6
                            ? {
                                'border-right': 'white',
                              }
                            : {},
                          index2 == 23
                            ? {
                                'border-bottom': 'white',
                              }
                            : {},
                        ]"
                      >
                        <div v-if="index == 0">
                          <div class="timeContent">
                            {{ hour.time }}
                          </div>
                        </div>
                        <div
                          v-for="(event, eventIndex) in hour.events"
                          :key="eventIndex"
                        >
                          <div v-if="event.days.length == 1">
                            <WeekItem
                              :event="event"
                              :day="day"
                              :events="events"
                              :hour="hour"
                              :index="eventIndex"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="this.option == 'Schedule'">
                <div class="scheduleBox">
                  <div
                    v-for="(scheduleDay, index1) in allEvents"
                    :key="index1"
                    class="scheduleDayAll"
                  >
                    <div class="scheduleDay">{{ dateList[index1] }}</div>
                    <div
                      class="eventSchedule"
                      v-for="(dayEvent, index2) in scheduleDay"
                      :key="index2"
                    >
                      <div class="colourEvent" :style="scheduleStyle"></div>
                      <div class="scheduleEventInfo">
                        {{ timeList[index1][index2] }}
                      </div>
                      <div class="scheduleEventTitle">
                        {{ dayEvent.title }}
                        <span v-if="dayEvent.repeatId">(repeating)</span>
                      </div>
                    </div>
                    <div class="eventSchedule" v-if="scheduleDay.length == 0">
                      No event today
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div
              class="innerCalendarCard"
              style="margin-right: 0 !important"
              v-if="this.option == 'Month'"
            >
              <div class="monthBar">
                {{ this.nextMonth }} {{ this.nextYear }} ({{ this.nameGroup }})
              </div>
              <div class="dateBar">
                <div
                  class="dateBarContent"
                  v-for="(day, index) in days"
                  :key="index"
                >
                  {{ day }}
                </div>
              </div>
              <div
                class="calendarWeek"
                v-for="(week, index) in weeks"
                :key="index"
                :class="{ isLastCalendarWeek: index == weeks.length - 1 }"
              >
                <div
                  class="dateBox"
                  v-for="(day, date) in week"
                  :key="date"
                  :class="{ isLastDateBox: date == 6 }"
                >
                  <div
                    class="dateNumber"
                    v-if="day.num != 0 && day.num != startNum"
                  >
                    {{ day.num }}
                  </div>
                  <div
                    class="dateNumber"
                    v-if="
                      day.num != 0 &&
                        day.num == startNum &&
                        day.month + 1 != startMonth
                    "
                  >
                    {{ day.num }}
                  </div>
                  <div
                    class="curNumber"
                    v-if="day.num == startNum && day.month + 1 == startMonth"
                  >
                    {{ day.num }}
                  </div>
                </div>
              </div>
            </div>
            <div
              class="innerCalendarCard"
              v-else-if="this.option == 'Week'"
              style="margin-right: 0 !important"
            ></div>
            <div id="innerScrollOpacity"></div>
            <span
              v-if="this.option != 'Schedule'"
              class="calScrollArrow calRightArrow"
              @click="changeCalendar('right')"
            >
              <img src="@/assets/Calendar/calArrow.svg" />
            </span>
          </div>
        </div>
        <div class="floatRightContainer">
          <router-link
            class="componentRoute navChat"
            @click.native="setMessageBoard"
            :class="{
              onChat: onMessageBoard,
            }"
            :to="{
              name: 'MessageBoard',
              params: {
                name: this.groupName.replace(/\s/g, '-'),
                id: this.groupId,
              },
            }"
          ></router-link>
          <router-link
            class="componentRoute navCalendar"
            @click.native="setCalendar"
            :class="{
              onCal: onCalendar,
            }"
            :to="{
              name: 'Calendar',
              params: {
                name: this.groupName.replace(/\s/g, '-'),
                id: this.groupId,
              },
            }"
          ></router-link>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import moment from "moment";
import Navbar from "@/components/Navbar";
import AddEvent from "@/components/calendar/AddCalendarEvent";
import CalendarItem from "@/components/calendar/CalendarItem";
import WeekItem from "@/components/calendar/WeekItem";
import MultiCalendarItem from "@/components/calendar/MultiCalendarItem";
import db from "@/db";
import { mapState } from "vuex";
export default {
  components: {
    Navbar,
    AddEvent,
    CalendarItem,
    MultiCalendarItem,
    WeekItem,
  },
  data: () => ({
    listeners: [],
    option: "Month",
    groupCal: "All",
    isWindows: false,
    currentImg: "",
    tmp: [0, 1],
    adding: 0,
    boxX: 0,
    boxY: 1,
    days: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
    weeks: [[], [], [], [], []],
    numbers: [0, 1, 2, 3, 4, 5, 6, 7],
    showAllGroups: false,
    events: [],
    curDate: null,
    curHour: -1,
    monthNumber: 0,
    dateWidth: 0,
    startMonth: Number(moment().format("M")),
    startNum: moment().format("DD"),
    curMonth: moment().format("MMMM"),
    curYear: moment().format("YYYY"),
    curWeek:
      moment().week() -
      moment()
        .startOf("month")
        .week(),
    lastMonth: "",
    lastYear: "",
    lastWeek: "",
    nextMonth: "",
    nextYear: "",
    nextWeek: "",
    fetchWeeks: [],
    numberOfEvents: 0,
    blankEvent: {
      title: "(No Title)",
      startDate: null,
      endDate: null,
      numDays: 1,
      location: "",
      weeks: [],
      days: [1],
      showDetails: false,
      type: "#e74c3c",
    },
    emptyEvent: {
      title: null,
      startDate: null,
      endDate: null,
      numDays: 1,
      location: "",
      weeks: [],
      days: [],
      showDetails: false,
      type: "#e74c3c",
    },
    activityOption: ["class", "assessment", "assignment", "office", "other"],
    toggledAssessment: true,
    toggledClass: true,
    toggledAssignment: true,
    toggledOffice: true,
    toggledOther: true,
    toggledNon: true,
    controlScroll: true,
    isScrolling: false,
    allEvents: [],
    timeList: [],
    dateList: [],
    nameGroup: "",
  }),
  created() {
    window.addEventListener("resize", this.myEventHandler);
    //this.groupCal = this.groupName;
    this.nameGroup = this.groupName;
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },
  mounted() {
    this.events = [];
    this.initiatScroll();
    this.initiateDates();
    this.setCalendarDays();
    this.fetchEvents(this.groupId);
    this.isWindows = this.checkOS();
    this.fetchGroupInfo();
    this.numberOfEvents = Math.floor(
      (window.innerHeight - 87) / (this.weeks.length * 40)
    );
    this.fetchGroupEvent();
  },
  watch: {
    groupId() {
      this.detachListeners();
      this.events = [];
      console.log("Calendar");
      this.setCalendarDays();
      this.fetchEvents(this.groupId);
    },
    option() {
      this.detachListeners();
      if (this.option == "Month") {
        this.events = [];
        this.setCalendarDays();
        if (this.showAllGroups) {
          this.showAllGroups = false;
          this.fetchAllGroupEvents();
        } else {
          this.fetchEvents(this.groupId);
        }
      } else {
        this.events = [];
        this.setCalendarDays();
        if (this.showAllGroups) {
          this.showAllGroups = false;
          this.fetchAllGroupEvents();
        } else {
          this.fetchWeekEvents(this.groupId);
        }
      }
    },
    groupCal() {
      this.detachListeners();
      if (this.groupCal == "All") {
        this.showAllGroups = false;
        this.fetchAllGroupEvents();
      } else {
        this.showAllGroups = false;
        this.$store.commit("messageBoard/setGroupId", this.groupCal.id);
        this.nameGroup = this.groupCal.name;
      }
    },
  },
  computed: {
    ...mapState("messageBoard", ["groupId", "groupName", "curGroup"]),
    ...mapState("calendar", ["isAddingEvent"]),
    ...mapState("user", ["user"]),
    ...mapState("calendar", ["showDetails"]),
    ...mapState("calendar", ["showMulti"]),
    ...mapState("mainPage", [
      "onMessageBoard",
      "onCalendar",
      "onReview",
      "onUpload",
    ]),

    scheduleStyle() {
      return { "background-color": "#0fb9b1" };
    },
    addStyle() {
      var offsetX = 0;
      var offsetY = 0;
      var diffX = 0;
      /*if (this.boxX == 0) {
        offsetX = 16;
      } else if (this.boxX == 1) {
        offsetX = 14;
      } else if (this.boxX == 2) {
        offsetX = 12;
      }*/
      offsetX = 16 - this.boxX * 2;
      if (this.boxX > 4) {
        diffX = 1;
      }
      if (this.boxY == 0) {
        offsetY = 20;
      } else if (this.boxY == 1) {
        offsetY = 35;
      } else if (this.boxY == 2) {
        if (this.boxX > 4) {
          diffX = 2;
        } else {
          diffX = -1;
        }
      } else if (this.boxY == 3) {
        offsetY = 1;
      } else if (this.boxY == 4) {
        offsetY = 15;
      } else {
        offsetY = 15;
      }
      return {
        //top: 20 + this.boxY * 2 + "%",
        top: offsetY + this.boxY * 2 + "vh",
        left: offsetX + (this.boxX - diffX) * 13 + "vw",
      };
    },
  },
  methods: {
    fetchGroupEvent() {
      var pastDate = Date.now();
      var tempDate = new Date(Date.now());
      var dayDate = tempDate.toString().slice(4, 10);
      //dateList.push(dayDate);
      var dayList = [];
      var allTimes = [];
      var tempTime;
      db.collection("calendarEvents")
        .where("group_id", "==", this.groupId)
        .where("startDate", ">=", Date.now())
        .orderBy("startDate", "asc")
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            //this.allEvents.push(doc.data());
            if (doc.data().startDate <= pastDate + 86400000) {
              dayList.push(doc.data());
              if (doc.data().isAllDay) {
                allTimes.push("All day");
              } else {
                tempTime = new Date(doc.data().startDate);
                allTimes.push(tempTime.toString().slice(15, 21));
              }
            } else {
              this.allEvents.push(dayList);
              dayList = [];
              dayList.push(doc.data());
              this.timeList.push(allTimes);
              allTimes = [];
              if (doc.data().isAllDay) {
                allTimes.push("All day");
              } else {
                tempTime = new Date(doc.data().startDate);
                allTimes.push(tempTime.toString().slice(15, 21));
              }
              this.dateList.push(dayDate);
              pastDate = doc.data().startDate;
              tempDate = new Date(pastDate);
              dayDate = tempDate.toString().slice(4, 10);
            }
          });
        });
    },
    toggleFilter(numFilter) {
      switch (numFilter) {
        case 0:
          this.toggledAssessment = !this.toggledAssessment;
          this.toggleActivity("assessment");
          break;
        case 1:
          this.toggledClass = !this.toggledClass;
          this.toggleActivity("class");
          break;
        case 2:
          this.toggledAssignment = !this.toggledAssignment;
          this.toggleActivity("assignment");
          break;
        case 3:
          this.toggledOffice = !this.toggledOffice;
          this.toggleActivity("office");
          break;
        case 4:
          this.toggledOther = !this.toggledOther;
          this.toggleActivity("other");
          break;
        case 5:
          this.toggledNon = !this.toggledNon;
          break;
      }
    },
    fetchGroupInfo() {
      db.collection("groups")
        .doc(this.groupId)
        .get()
        .then((doc) => {
          if (!doc.exists) {
            this.fetchCourseInfo();
            return;
          } else {
            this.currentImg = doc.data().profileImage;
          }
        });
    },
    fetchCourseInfo() {
      db.collection("courses")
        .doc(this.groupId)
        .get()
        .then((doc) => {
          if (!doc.exists) {
            this.fetchFacultyInfo();
            return;
          } else {
            this.currentImg = doc.data().profileImage;
          }
        });
    },
    fetchFacultyInfo() {
      db.collection("faculties")
        .doc(this.groupId)
        .get()
        .then((doc) => {
          if (doc.exists) {
            this.currentImg = doc.data().profileImage;
          }
        });
    },
    detachListeners() {
      this.listeners.forEach((listener) => listener());
      this.listeners = [];
    },
    setMessageBoard() {
      this.$store.commit("mainPage/setMessageBoard");
    },
    setCalendar() {
      this.$store.commit("mainPage/setCalendar");
    },
    viewCalendar(calType) {
      this.option = calType;
    },
    setFetchWeeks() {
      this.fetchWeeks = [];
      let start = moment()
        .add(this.monthNumber, "M")
        .startOf("month")
        .week();
      let end = moment()
        .add(this.monthNumber, "M")
        .endOf("month")
        .week();
      for (let i = start; i <= end; i++) {
        this.fetchWeeks.push(i);
      }
    },
    fetchAllGroupEvents() {
      if (!this.showAllGroups) {
        this.showAllGroups = true;
        this.setCalendarDays();
        if (this.option == "Week") {
          this.user.courses.forEach((course) =>
            this.fetchWeekEvents(course.id)
          );
          this.user.faculties.forEach((fac) => this.fetchWeekEvents(fac.id));
          this.user.groups.forEach((group) => this.fetchWeekEvents(group.id));
        } else {
          this.user.courses.forEach((course) => this.fetchEvents(course.id));
          this.user.faculties.forEach((fac) => this.fetchEvents(fac.id));
          this.user.groups.forEach((group) => this.fetchEvents(group.id));
        }
      } else {
        this.showAllGroups = false;
        this.setCalendarDays();
        if (this.option == "Week") {
          this.fetchWeekEvents(this.groupId);
        } else {
          this.fetchEvents(this.groupId);
        }
      }
    },
    handleClick(event) {
      if (
        event.target.className != "event" &&
        event.target.className != "eventBox" &&
        event.target.className != "field-input" &&
        this.adding != 0
      ) {
        this.setIsAddingEvent(false);
        this.removeBlank();
        this.curHour = -1;
      }
      if (
        event.target.className == "dateBox" ||
        event.target.className == "timeBox"
      ) {
        this.adding += 1;
      }
    },
    removeBlank() {
      if (
        this.curHour != -1 &&
        this.weeks[this.curWeek][this.boxX].hours[this.curHour].events.length >
          0
      ) {
        if (
          this.weeks[this.curWeek][this.boxX].hours[this.curHour].events[0]
            .startDate == null
        ) {
          this.weeks[this.curWeek][this.boxX].hours[this.curHour].events.splice(
            0,
            1
          );
        }
      }
      for (var week = 0; week < this.weeks.length; week++) {
        for (var day = 0; day < this.weeks[week].length; day++) {
          for (var ev = 0; ev < this.weeks[week][day].events.length; ev++) {
            if (this.weeks[week][day].events[ev].startDate == null) {
              this.weeks[week][day].events.splice(ev, 1);
            }
          }
        }
      }
    },
    getMonthName() {
      return moment()
        .add(this.monthNumber, "M")
        .format("MMMM");
    },
    initiatScroll() {
      var boxWidth = document.getElementById("innerCalendarCardWidth")
        .offsetWidth;
      let content = document.querySelector(".outerCalendarCard");
      content.scrollLeft += boxWidth + 10;
    },
    calScroll: function(el) {
      //document.getElementById("whiteOverlap").style.display = "flex";
      this.isScrolling = true;
      var boxWidth = document.getElementById("innerCalendarCardWidth")
        .offsetWidth;
      if (
        el.srcElement.offsetWidth + el.srcElement.scrollLeft >=
          el.srcElement.scrollWidth &&
        this.controlScroll
      ) {
        this.changeCalendar("right");
        setTimeout(() => {
          let content = document.querySelector(".outerCalendarCard");
          content.scrollLeft += -boxWidth - 10;
          this.controlScroll = false;
        }, 150);
        setTimeout(() => {
          this.controlScroll = true;
        }, 150);
      } else if (el.srcElement.scrollLeft == 0) {
        this.changeCalendar("left");
        setTimeout(() => {
          let content = document.querySelector(".outerCalendarCard");
          content.scrollLeft += boxWidth + 10;
          this.controlScroll = false;
          this.isScrolling = false;
        }, 150);
        setTimeout(() => {
          this.controlScroll = true;
        }, 150);
      }
    },
    changeCalendar(direction) {
      if (direction == "left" && this.option == "Month") {
        this.goLastMonth();
      } else if (direction == "left" && this.option == "Week") {
        this.goLastWeek();
      } else if (direction == "right" && this.option == "Month") {
        this.goNextMonth();
      } else if (direction == "right" && this.option == "Week") {
        this.goNextWeek();
      }
    },
    goNextWeek() {
      this.detachListeners();
      this.curWeek++;
      if (this.curWeek == this.weeks.length) {
        this.goNextMonth();
        this.curWeek = 1;
      }
      this.setCalendarDays();
      if (this.showAllGroups) {
        this.showAllGroups = false;
        this.fetchAllGroupEvents();
      } else {
        this.fetchWeekEvents(this.groupId);
      }
      console.log(this.weeks);
    },
    goLastWeek() {
      this.detachListeners();
      this.curWeek--;
      if (this.curWeek < 0) {
        this.goLastMonth();
        this.curWeek =
          moment()
            .add(this.monthNumber, "M")
            .endOf("month")
            .week() -
          moment()
            .add(this.monthNumber, "M")
            .startOf("month")
            .week();
        this.curWeek--;
      }
      this.setCalendarDays();
      if (this.showAllGroups) {
        this.showAllGroups = false;
        this.fetchAllGroupEvents();
      } else {
        this.fetchWeekEvents(this.groupId);
      }
      console.log(this.weeks[this.curWeek]);
    },
    goNextMonth() {
      this.detachListeners();
      this.monthNumber++;
      this.curMonth = moment()
        .add(this.monthNumber, "M")
        .format("MMMM");
      this.curYear = moment()
        .add(this.monthNumber, "M")
        .format("YYYY");
      if (this.curMonth == moment().format("MMMM")) {
        this.curWeek =
          moment().week() -
          moment()
            .startOf("month")
            .week();
      } else {
        this.curWeek = 0;
      }
      this.setCalendarDays();
      if (this.showAllGroups) {
        this.showAllGroups = false;
        this.fetchAllGroupEvents();
      } else {
        this.fetchEvents(this.groupId);
      }
      setTimeout(() => {
        this.initiateDates();
      }, 150);
    },
    initiateDates() {
      var prevMonthNumber = this.monthNumber - 1;
      var postMonthNumber = this.monthNumber + 1;
      this.lastMonth = moment()
        .add(prevMonthNumber, "M")
        .format("MMMM");
      this.lastYear = moment()
        .add(prevMonthNumber, "M")
        .format("YYYY");
      if (this.lastMonth == moment().format("MMMM")) {
        this.lastWeek =
          moment().week() -
          moment()
            .startOf("month")
            .week();
      } else {
        this.lastWeek = 0;
      }
      this.nextMonth = moment()
        .add(postMonthNumber, "M")
        .format("MMMM");
      this.nextYear = moment()
        .add(postMonthNumber, "M")
        .format("YYYY");
      if (this.nextMonth == moment().format("MMMM")) {
        this.nextWeek =
          moment().week() -
          moment()
            .startOf("month")
            .week();
      } else {
        this.nextWeek = 0;
      }
    },
    goLastMonth() {
      this.detachListeners();
      this.monthNumber--;
      this.curMonth = moment()
        .add(this.monthNumber, "M")
        .format("MMMM");
      this.curYear = moment()
        .add(this.monthNumber, "M")
        .format("YYYY");
      if (this.curMonth == moment().format("MMMM")) {
        this.curWeek =
          moment().week() -
          moment()
            .startOf("month")
            .week();
      } else {
        this.curWeek = 0;
      }
      this.setCalendarDays();
      if (this.showAllGroups) {
        this.showAllGroups = false;
        this.fetchAllGroupEvents();
      } else {
        this.fetchEvents(this.groupId);
      }
      setTimeout(() => {
        this.initiateDates();
      }, 150);
    },
    createEvent(event, id) {
      return {
        title: event.title,
        startDate: event.startDate,
        endDate: event.endDate,
        weeks: event.weeks,
        location: event.location,
        showDetails: false,
        type: event.type,
        id: id,
        frequency: event.frequency,
        isAllDay: event.isAllDay,
        repeatEndDate: event.repeatEndDate,
        repeatInterval: event.repeatInterval,
        repeatedDays: event.repeatedDays,
        repeatId: event.repeatId,
        repeatsString: event.repeatsString,
        description: event.description,
        days: event.days,
      };
    },
    setCalendarDays() {
      this.events = [];
      this.setFetchWeeks();
      const firstDayOfMonth = moment()
        .add(this.monthNumber, "M")
        .startOf("month")
        .day();
      const numDaysInMonth = moment()
        .add(this.monthNumber, "M")
        .daysInMonth();
      const firstWeek = moment()
        .add(this.monthNumber, "M")
        .startOf("month")
        .week();
      const lastWeek = moment()
        .add(this.monthNumber, "M")
        .endOf("month")
        .week();
      var totalDays = 0;
      //Check number of weeks in a month
      if (lastWeek - firstWeek == 4) {
        totalDays = 35;
        this.weeks = [[], [], [], [], []];
      } else if (lastWeek - firstWeek == 5) {
        totalDays = 42;
        this.weeks = [[], [], [], [], [], []];
      }
      //initialize calendar with all zeros
      for (var day = 0; day < totalDays; day++) {
        let totalHours = [];
        let twelve = {
          time: "12am",
          hour: 0,
          events: [],
        };
        totalHours.push(twelve);
        for (let hour = 1; hour < 24; hour++) {
          let ending = "am";
          let diff = 0;
          if (hour == 12) {
            ending = "pm";
          } else if (hour > 12) {
            ending = "pm";
            diff = 12;
          }
          let hours = {
            time: hour - diff + ending,
            hour: hour,
            events: [],
          };
          totalHours.push(hours);
        }
        this.weeks[Math.floor(day / 7)].push({
          num: 0,
          events: [],
          week: 0,
          weekNum: 0,
          date: 0,
          dateInMs: 0,
          month: 0,
          hours: totalHours,
        });
      }

      //set last months dates
      var subtractVal = firstDayOfMonth - 1;
      for (var prev = 0; prev < firstDayOfMonth; prev++) {
        let dateValue = moment()
          .add(this.monthNumber, "M")
          .subtract(1, "M")
          .endOf("month")
          .subtract(subtractVal, "days");
        this.weeks[Math.floor(prev / 7)][prev % 7].num = dateValue.format("DD");
        this.weeks[Math.floor(prev / 7)][prev % 7].date =
          dateValue.format("Y") +
          "-" +
          dateValue.format("MM") +
          "-" +
          dateValue.format("DD") +
          "T" +
          dateValue.format("hh:mm");
        this.weeks[Math.floor(prev / 7)][prev % 7].dateInMs = new Date(
          dateValue
        ).getTime();
        this.weeks[Math.floor(prev / 7)][prev % 7].month = dateValue.month();
        subtractVal--;
      }
      //set correct calendar dates
      for (day = 1; day <= numDaysInMonth; day++) {
        var offset = day + firstDayOfMonth - 1;
        this.weeks[Math.floor(offset / 7)][offset % 7].num = day;
        var dateValue = moment()
          .add(this.monthNumber, "M")
          .startOf("month")
          .add(day - 1, "days");
        this.weeks[Math.floor(offset / 7)][offset % 7].date =
          dateValue.format("Y") +
          "-" +
          dateValue.format("MM") +
          "-" +
          dateValue.format("DD") +
          "T" +
          dateValue.format("hh:mm");
        this.weeks[Math.floor(offset / 7)][offset % 7].dateInMs = new Date(
          dateValue
        ).getTime();
        this.weeks[Math.floor(offset / 7)][
          offset % 7
        ].month = dateValue.month();
      }
      //set next months dates
      var endIndex = moment()
        .add(this.monthNumber, "M")
        .endOf("month")
        .day();
      var addValue = 0;
      for (var next = endIndex + 1; next < 7; next++) {
        let dateValue = moment()
          .add(this.monthNumber, "M")
          .add(1, "M")
          .startOf("month")
          .add(addValue, "days");
        this.weeks[this.weeks.length - 1][next].num = dateValue.format("D");
        this.weeks[this.weeks.length - 1][next].date =
          dateValue.format("Y") +
          "-" +
          dateValue.format("MM") +
          "-" +
          dateValue.format("DD") +
          "T" +
          dateValue.format("hh:mm");
        this.weeks[this.weeks.length - 1][next].dateInMs = new Date(
          dateValue
        ).getTime();
        this.weeks[this.weeks.length - 1][next].month = dateValue.month();
        addValue++;
      }
    },
    async fetchEvents(groupId) {
      let listener = db
        .collection("calendarEvents")
        .where("group_id", "==", groupId)
        .where("weeks", "array-contains-any", this.fetchWeeks)
        .orderBy("startDate", "asc")
        .onSnapshot((calendarEvents) => {
          console.log("Fetched");
          calendarEvents.docChanges().forEach((calendarEvent) => {
            if (calendarEvent.type === "added") {
              if (
                this.events.findIndex((x) => x.id == calendarEvent.doc.id) == -1
              ) {
                let event = this.createEvent(
                  calendarEvent.doc.data(),
                  calendarEvent.doc.id
                );
                this.addToCalendarBox(event, calendarEvent.doc.id);
              }
            }
            if (calendarEvent.type === "modified") {
              let event3 = this.createEvent(
                calendarEvent.doc.data(),
                calendarEvent.doc.id
              );
              this.removeFromCalendar(event3);
              if (
                this.events.findIndex((x) => x.id == calendarEvent.doc.id) == -1
              ) {
                this.addToCalendarBox(event3, calendarEvent.doc.id);
              }
            }
            if (calendarEvent.type === "removed") {
              let event2 = this.createEvent(
                calendarEvent.doc.data(),
                calendarEvent.doc.id
              );
              this.removeFromCalendar(event2);
            }
          });
          console.log(this.events);
        });
      this.listeners.push(listener);
    },
    async fetchWeekEvents(groupId) {
      let listener = db
        .collection("calendarEvents")
        .where("group_id", "==", groupId)
        .where("weeks", "array-contains", this.fetchWeeks[this.curWeek])
        .orderBy("startDate", "asc")
        .onSnapshot((calendarEvents) => {
          calendarEvents.docChanges().forEach((calendarEvent) => {
            if (calendarEvent.type === "added") {
              if (
                this.events.findIndex((x) => x.id == calendarEvent.doc.id) == -1
              ) {
                let event = this.createEvent(
                  calendarEvent.doc.data(),
                  calendarEvent.doc.id
                );
                this.addToCalendarBox(event, calendarEvent.doc.id);
              }
            }
            if (calendarEvent.type === "modified") {
              let event3 = this.createEvent(
                calendarEvent.doc.data(),
                calendarEvent.doc.id
              );
              this.removeFromCalendar(event3);
              if (
                this.events.findIndex((x) => x.id == calendarEvent.doc.id) == -1
              ) {
                this.addToCalendarBox(event3, calendarEvent.doc.id);
              }
            }
            if (calendarEvent.type === "removed") {
              let event2 = this.createEvent(
                calendarEvent.doc.data(),
                calendarEvent.doc.id
              );
              this.removeFromCalendar(event2);
            }
          });
        });
      await this.listeners.push(listener);
    },
    removeFromCalendar(event) {
      var index = this.events.findIndex((x) => x.id == event.id);
      this.events.splice(index, 1);
      for (var week = 0; week < this.weeks.length; week++) {
        for (var day = 0; day < this.weeks[week].length; day++) {
          for (var ev = 0; ev < this.weeks[week][day].events.length; ev++) {
            if (this.weeks[week][day].events[ev].id == event.id) {
              this.weeks[week][day].events.splice(ev, 1);
              for (
                let i = moment(event.startDate).format("H");
                i <= moment(event.endDate).format("H");
                i++
              ) {
                var events = this.weeks[week][day].hours[i].events;
                for (let j = 0; j < events.length; j++) {
                  if (events[j].id == event.id) {
                    this.weeks[week][day].hours[i].events.splice(j, 1);
                  }
                }
              }
            }
          }
        }
      }
    },
    addToCalendarBox(event, id) {
      if (!this.activityOption.includes(event.type)) {
        return;
      }
      this.removeBlank();
      let startDay = Number(moment(event.startDate).format("D"));
      let curWeek = moment()
        .add(this.monthNumber, "M")
        .startOf("month")
        .week();
      let lastWeek = moment()
        .add(this.monthNumber, "M")
        .endOf("month")
        .week();
      const firstDayOfMonth = moment()
        .add(this.monthNumber, "M")
        .startOf("month")
        .day();
      const firstWeekFirstDay = moment()
        .add(this.monthNumber, "M")
        .subtract(1, "M")
        .endOf("month")
        .startOf("week")
        .format("D");
      const lastMonthLastDay = moment()
        .add(this.monthNumber, "M")
        .subtract(1, "M")
        .endOf("month")
        .format("D");
      const firstDay = new Date(
        moment()
          .add(this.monthNumber, "M")
          .startOf("month")
      ).getTime();
      const lastDay = new Date(
        moment()
          .add(this.monthNumber, "M")
          .endOf("month")
      ).getTime();
      const firstCalendarDay = new Date(
        moment()
          .add(this.monthNumber, "M")
          .subtract(1, "M")
          .endOf("month")
          .startOf("week")
      ).getTime();
      let blockEvent = {
        title: null,
        startDate: 0,
        endDate: null,
        numDays: 1,
        location: "",
        weeks: [],
        days: [],
        showDetails: false,
        type: "#e74c3c",
      };
      let numDays = (event.endDate - event.startDate) / 86400000;
      // add last months events
      if (event.startDate < firstDay && event.weeks.includes(curWeek)) {
        let subtractVal = firstDayOfMonth - 1;
        let additionalDif = 0;
        if (firstWeekFirstDay > startDay) {
          additionalDif = (firstWeekFirstDay - startDay) * 86400000;
          startDay = firstWeekFirstDay;
          numDays = (event.endDate - firstCalendarDay) / 86400000;
        }
        for (var prev = 0; prev <= numDays; prev++) {
          let weekDay =
            (subtractVal - (lastMonthLastDay - startDay) + prev) % 7;
          let week = Math.floor(
            (subtractVal - (lastMonthLastDay - startDay) + prev) / 7
          );
          let eventCopy = this.createEvent(event, id);
          let dayDif = prev * 86400000;
          this.events.push(eventCopy);
          this.weeks[week][weekDay].events.push(eventCopy);
          if (numDays <= 1 && !event.isAllDay) {
            for (
              let i = Number(moment(event.startDate).format("HH"));
              i <= Number(moment(event.endDate).format("HH"));
              i++
            ) {
              this.weeks[week][weekDay].hours[i].events.push(eventCopy);
            }
          }
          if (weekDay >= 1) {
            let indexOf = this.weeks[week][weekDay].events.indexOf(eventCopy);
            let indexOf2 = this.weeks[week][weekDay - 1].events.findIndex(
              (x) => x.id == eventCopy.id
            );
            if (indexOf2 != -1) {
              if (indexOf != indexOf2) {
                let blockDif = indexOf2 - indexOf;
                for (let dif = 0; dif < blockDif; dif++) {
                  this.weeks[week][weekDay].events.unshift(blockEvent);
                }
              }
              let newIndex = this.weeks[week][weekDay].events.indexOf(
                eventCopy
              );
              if (indexOf2 != newIndex) {
                this.weeks[week][weekDay].events.splice(newIndex, 1);
                this.weeks[week][weekDay].events.splice(indexOf2, 0, eventCopy);
              }
            }
          }
          this.weeks[week][weekDay].week = moment(
            event.startDate + dayDif + additionalDif
          ).week();
          this.weeks[week][weekDay].weekNum = moment(
            event.startDate + dayDif + additionalDif
          ).day();
        }
      }
      // add current months events
      else if (event.startDate >= firstDay && event.startDate <= lastDay) {
        for (var day = 0; day <= numDays; day++) {
          let week = Math.floor((startDay + day + firstDayOfMonth - 1) / 7);
          let weekDay = (startDay + day + firstDayOfMonth - 1) % 7;
          let eventCopy = this.createEvent(event, id);
          let dayDif = day * 86400000;
          if (week < this.weeks.length) {
            this.events.push(eventCopy);
            this.weeks[week][weekDay].events.push(eventCopy);
            if (numDays <= 1 && !event.isAllDay) {
              for (
                let i = Number(moment(event.startDate).format("HH"));
                i <= Number(moment(event.endDate).format("HH"));
                i++
              ) {
                this.weeks[week][weekDay].hours[i].events.push(eventCopy);
              }
            }
            if (weekDay >= 1) {
              let indexOf = this.weeks[week][weekDay].events.indexOf(eventCopy);
              let indexOf2 = this.weeks[week][weekDay - 1].events.findIndex(
                (x) => x.id == eventCopy.id
              );
              if (indexOf2 != -1) {
                if (indexOf != indexOf2) {
                  let blockDif = indexOf2 - indexOf;
                  for (let dif = 0; dif < blockDif; dif++) {
                    this.weeks[week][weekDay].events.unshift(blockEvent);
                  }
                }
                let newIndex = this.weeks[week][weekDay].events.indexOf(
                  eventCopy
                );
                if (indexOf2 != newIndex) {
                  this.weeks[week][weekDay].events.splice(newIndex, 1);
                  this.weeks[week][weekDay].events.splice(
                    indexOf2,
                    0,
                    eventCopy
                  );
                }
              }
            }
            this.weeks[week][weekDay].week = moment(
              event.startDate + dayDif
            ).week();
            this.weeks[week][weekDay].weekNum = moment(
              event.startDate + dayDif
            ).day();
          }
        }
      }
      // add next months events
      else if (event.startDate > lastDay && event.weeks.includes(lastWeek)) {
        let endIndex = moment()
          .add(this.monthNumber, "M")
          .endOf("month")
          .day();
        for (var next = 0; next <= numDays; next++) {
          let weekDay = endIndex + startDay + next;
          let week = this.weeks.length - 1;
          if (weekDay < 7) {
            let eventCopy = this.createEvent(event, id);
            let dayDif = next * 86400000;
            this.events.push(eventCopy);
            this.weeks[week][weekDay].events.push(eventCopy);
            if (numDays <= 1 && !event.isAllDay) {
              for (
                let i = Number(moment(event.startDate).format("HH"));
                i <= Number(moment(event.endDate).format("HH"));
                i++
              ) {
                this.weeks[week][weekDay].hours[i].events.push(eventCopy);
              }
            }
            let indexOf = this.weeks[week][weekDay].events.indexOf(eventCopy);
            let indexOf2 = this.weeks[week][weekDay - 1].events.findIndex(
              (x) => x.id == eventCopy.id
            );
            if (indexOf2 != -1) {
              if (indexOf != indexOf2) {
                let blockDif = indexOf2 - indexOf;
                for (let dif = 0; dif < blockDif; dif++) {
                  this.weeks[week][weekDay].events.unshift(blockEvent);
                }
              }
              let newIndex = this.weeks[week][weekDay].events.indexOf(
                eventCopy
              );
              if (indexOf2 != newIndex) {
                this.weeks[week][weekDay].events.splice(newIndex, 1);
                this.weeks[week][weekDay].events.splice(indexOf2, 0, eventCopy);
              }
            }
            this.weeks[week][weekDay].week = moment(
              event.startDate + dayDif
            ).week();
            this.weeks[week][weekDay].weekNum = moment(
              event.startDate + dayDif
            ).day();
          }
        }
      }
    },
    showBox(week, day, valid, event, hour) {
      if (
        (event.target.className == "dateBox" ||
          event.target.className == "timeBox") &&
        valid.num != 0 &&
        !this.showAllGroups &&
        !this.isAddingEvent
      ) {
        this.boxX = day;
        this.boxY = week;
        this.curHour = hour;
        let newHour = moment(valid.date).set("hour", hour);
        valid.date = newHour;
        this.$store.commit("calendar/setShowMulti", false);
        this.adding = 0;
        this.hideAllEventDetails();
        this.setIsAddingEvent(false);
        this.curDate = valid;
        for (var num = 0; num < 7; num++) {
          this.weeks[week][num].events.unshift(this.emptyEvent);
        }
        this.weeks[week][day].events[0] = this.blankEvent;
        this.weeks[this.curWeek][day].hours[hour].events.unshift(
          this.blankEvent
        );
        this.setIsAddingEvent(true);
      }
    },
    hidePreviousEventDetails(event) {
      for (const index in this.events) {
        if (this.events[index] != event) {
          this.events[index].showDetails = false;
        }
      }
    },
    toggleIsAddingEvent() {
      this.$store.commit("calendar/setIsAddingEvent", !this.isAddingEvent);
    },
    setIsAddingEvent(bol) {
      this.$store.commit("calendar/setIsAddingEvent", bol);
    },
    checkStartDate(event, day) {
      if (event.startDate) {
        let startDay = Number(moment(event.startDate).format("D"));
        if (startDay === day.num) {
          return true;
        }
      }
      return false;
    },
    checkStartWeek(event, day) {
      if (event.startDate != null) {
        if (day.weekNum == 0) {
          return true;
        }
      }
      return false;
    },
    checkEmpty(event) {
      if (event.startDate == null && event.name == null) {
        return true;
      }
      return false;
    },
    hideAllEventDetails() {
      for (const index in this.events) {
        this.events[index].showDetails = false;
      }
    },
    checkOS() {
      if (navigator.appVersion.indexOf("Win") != -1) {
        return true;
      }
      return false;
    },
    checkState() {
      if (this.option == "Month") {
        this.events = [];
        this.setCalendarDays();
        if (this.showAllGroups) {
          this.showAllGroups = false;
          this.fetchAllGroupEvents();
        } else {
          this.fetchEvents(this.groupId);
        }
      } else {
        this.events = [];
        this.setCalendarDays();
        if (this.showAllGroups) {
          this.showAllGroups = false;
          this.fetchAllGroupEvents();
        } else {
          this.fetchWeekEvents(this.groupId);
        }
      }
    },
    toggleActivity(activity) {
      if (this.activityOption.includes(activity)) {
        const index = this.activityOption.indexOf(activity);
        this.activityOption.splice(index, 1);
        this.checkState();
      } else {
        this.activityOption.push(activity);
        console.log(this.activityOption);
        this.checkState();
      }
    },
  },
};
</script>
<style src="@/styles/views/Calendar.css"></style>
